import { Modal } from "./modal.item";
import { TestComponent } from "../../test/test.component";
import { ProfileNavbarComponent } from "../profile/profile-navbar/profile-navbar.component";
import { ChangePasswordComponent } from "../profile/change-password/change-password.component";
import { BankDetailsComponent } from "../profile/bank-details/bank-details.component";
import { MyAuctionsComponent } from "../profile/my-auctions/my-auctions.component";
import { FavoritesComponent } from "../profile/favorites/favorites.component";
import { NotificationsComponent } from "../profile/notifications/notifications.component";
import { TransactionHistoryComponent } from "../profile/transaction-history/transaction-history.component";
import { PersonalInformationComponent } from "../profile/personal-information/personal-information.component";
import { FillBalanceComponent } from "../../components/balance/fill-balance/fill-balance.component";
import { WithdrawBalanceComponent } from "../../components/balance/withdraw-balance/withdraw-balance.component";
import { TermsAndConditionsPopupComponent } from "../../components/terms-and-conditions-popup/terms-and-conditions-popup.component";
import { OutbiddedMessageComponent } from "../../components/auction-parts/outbidded-message/outbidded-message.component";
export class modalComponentsListDataModel {
  static getList() {
    let componentList: any = {};
    componentList["TestComponent"] = new Modal(TestComponent).component;
    componentList["ProfileNavbarComponent"] = new Modal(
      ProfileNavbarComponent,
    ).component;
    componentList["ChangePasswordComponent"] = new Modal(
      ChangePasswordComponent,
    ).component;
    componentList["BankDetailsComponent"] = new Modal(
      BankDetailsComponent,
    ).component;
    componentList["MyAuctionsComponent"] = new Modal(
      MyAuctionsComponent,
    ).component;
    componentList["FavoritesComponent"] = new Modal(
      FavoritesComponent,
    ).component;
    componentList["NotificationsComponent"] = new Modal(
      NotificationsComponent,
    ).component;
    componentList["TransactionHistoryComponent"] = new Modal(
      TransactionHistoryComponent,
    ).component;
    componentList["PersonalInformationComponent"] = new Modal(
      PersonalInformationComponent,
    ).component;
    componentList["FillBalanceComponent"] = new Modal(
      FillBalanceComponent,
    ).component;
    componentList["WithdrawBalanceComponent"] = new Modal(
      WithdrawBalanceComponent,
    ).component;
    componentList["TermsAndConditionsPopupComponent"] = new Modal(
      TermsAndConditionsPopupComponent,
    ).component;
    componentList["OutbiddedMessageComponent"] = new Modal(
      OutbiddedMessageComponent,
    ).component;
    return componentList;
  }
}
